export type IdpV2Category =
  | 'general'
  | 'custom'
  | 'identity_kyc'
  | 'financial_income_tax'
  | 'financial_wealth_obligations'
  | 'financial_sme_business'
  | 'property_collateral';

export type IdpV2EndpointKind = 'parse' | 'process';

export interface IdpV2Endpoint {
  id: string;
  slug: string;
  apiPath: string;
  docTypeKey?: string;
  name: string;
  description: string;
  category: IdpV2Category;
  kind: IdpV2EndpointKind;
}

export const IDP_V2_CATEGORY_LABELS: Record<IdpV2Category, string> = {
  general: 'General',
  custom: 'Custom',
  identity_kyc: 'Identity & KYC',
  financial_income_tax: 'Financial — Income & Tax',
  financial_wealth_obligations: 'Financial — Wealth & Obligations',
  financial_sme_business: 'Financial — SME / Business',
  property_collateral: 'Property & Collateral',
};

const IDP_V2_CATEGORIES = new Set<string>(Object.keys(IDP_V2_CATEGORY_LABELS));

/** Coerce API/tenant category strings into a known IdpV2Category (falls back to general). */
export function toIdpV2Category(category: string | null | undefined): IdpV2Category {
  if (category) {
    const trimmed = category.trim();
    if (IDP_V2_CATEGORIES.has(trimmed)) {
      return trimmed as IdpV2Category;
    }
    const lower = trimmed.toLowerCase();
    if (lower.includes('custom') || lower.includes('other')) {
      return 'custom';
    }
  }
  return 'general';
}
